import React, { FC } from 'react';
import EventCharts from '@components/machines/components/eventsChart';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import Paid from '@components/ncFiles/components/paid';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { loadSingleBatch } from '@reducers/batch';

interface ProductionOrderDetailsNCFilePerformancePaidProps extends ProductionOrderScreenProps {}

const ProductionOrderDetailsNCFilePerformancePaidComponent: FC<ProductionOrderDetailsNCFilePerformancePaidProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
    getAllNcFiles: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <EventCharts getContentElement={(props) => <Paid {...props} />} />
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsNCFilePerformancePaid = connect(null, {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsNCFilePerformancePaidComponent);

export { ProductionOrderDetailsNCFilePerformancePaid };
